<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="guia-de-estilo-2021" stroke="none" stroke-width="1" :fill="color" fill-rule="nonzero">
      <g
        id="06-Iconos-"
        transform="translate(-715.000000, -610.000000)"
        :fill="color"
        fill-rule="nonzero"
      >
        <g id="Group-4" transform="translate(142.000000, 610.000000)">
          <g id="Icon/icn_chevron-right" transform="translate(573.000000, 0.000000)">
            <path
              d="M18.1143819,16 L11.057191,23.057191 C10.5364919,23.57789 10.5364919,24.42211 11.057191,24.942809 C11.57789,25.4635081 12.42211,25.4635081 12.942809,24.942809 L20.942809,16.942809 C21.4635081,16.42211 21.4635081,15.57789 20.942809,15.057191 L12.942809,7.05719096 C12.42211,6.5364919 11.57789,6.5364919 11.057191,7.05719096 C10.5364919,7.57789001 10.5364919,8.42210999 11.057191,8.94280904 L18.1143819,16 Z"
              id="Shape"
            ></path>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export class IconChevronRight extends Vue {
  @Prop({ default: 26 }) public size!: number;
  @Prop({ default: "#ffffff" }) public color!: string;
}
export default IconChevronRight;
</script>
